import { isDevelopment } from '../../utils/environment'

/** Same path as Report Calendar in the Tax/EPR sidebar. */
export const REPORT_CALENDAR_PATH = '/report-calendar'

/** Same host rule as Sandbox: localhost and *.dev, hidden on prod. */
export const isReportCalendarMenuVisible = () => isDevelopment()
